import { waitForElem } from '../../utils/wait_for_elem';

waitForElem('.tags-search-box').then((searches) => {
  for (const s of searches) {
    s?.addEventListener('keyup', () => {
      searchTags();
    });
  }
});

waitForElem('.filter-name').then((filters) => {
  for (const f of filters) {
    f?.addEventListener('click', function() {
      const value = this.textContent ?? '';
      revealTags();
      searchTags('first', value);
    });
  }
})

const searchTags = (which = 'default', filter: string | null = null) => {
  revealTags();
  // Find the first visible .search input
  const searchInputs = document.querySelectorAll<HTMLInputElement>('.search');
  let visibleInput: HTMLInputElement | null = null;
  searchInputs.forEach(input => {
    if (input.offsetParent !== null) visibleInput = input;
  });
  const local_filter = filter ?? ((visibleInput as HTMLInputElement | null)?.value.toUpperCase() ?? '');
  const local_filter_lower = filter ?? ((visibleInput as HTMLInputElement | null)?.value.toLowerCase() ?? '');
  const tags = document.getElementsByClassName('blogTags') as HTMLCollectionOf<HTMLElement>;

  for (let a = 0; a < tags.length; a++) {
    const tag = tags[a].getElementsByClassName('lastNameFilter')[0] as HTMLElement | undefined;
    if (!tag) continue;
    const tag_clean = tag.innerHTML.trim().toUpperCase();
    const tag_clean_lower = tag.innerHTML.trim().toLowerCase();

    switch (which) {
      case 'default':
        if (tag_clean.includes(local_filter) || local_filter_lower.includes(tag_clean_lower)) {
          tags[a].style.display = "";
        } else {
          tags[a].style.display = "none";
        }
        break;
      case 'first':
        if (tag_clean.startsWith(local_filter) || local_filter_lower.includes(tag_clean_lower)) {
          tags[a].style.display = "";
        } else {
          tags[a].style.display = "none";
        }
        break;
    }
  }

  if (local_filter == '') {
    revealTags();
  }
}

const revealTags = () => {
  const tags = document.getElementsByClassName('blogTags') as HTMLCollectionOf<HTMLElement>;
  for (const t of Array.from(tags)) {
    t.style.display = "";
  }
}
